import React, { useEffect, useState } from "react";
import { BsNewspaper } from "react-icons/bs";
import {
  IoDocumentTextOutline,
  IoPeopleOutline,
  IoShieldCheckmarkOutline,
  IoCloudUploadOutline,
  IoNewspaperOutline,
} from "react-icons/io5";
import { FunctionOutlined } from "@ant-design/icons";
import { Button } from "../../components/Button/Button";
import { IoAlertCircleOutline } from "react-icons/io5";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { GetAllDynamic } from "../../Services/DynamicService";
import { log } from "console";
import {
  GetAllMasterData,
  GetMasterDataByTypeNames,
} from "../../Services/MasterDataService";
import { Col, Row } from "react-bootstrap";
interface Props {
  curPage: any;
  onSelectView: (text: string) => void;
  workList?: any;
  isCopy?: any;
  isVersion?: any;
}

type SideBarData = {
  component: any;
};

export const TemplateDetailSideBarElement = (props: Props) => {
  const [sideBarData, setSideBarData] = useState<SideBarData[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      let _sideBarData: SideBarData[] = [
        {
          component: (
            <Button
              onSelectView={props.onSelectView}
              title="Information"
              icon={<IoAlertCircleOutline />}
              page="information"
              curPage={props.curPage}
            />
          ),
        },
        {
          component: (
            <Button
              onSelectView={props.onSelectView}
              title="Form Design"
              icon={<BsNewspaper />}
              page="form_setting"
              curPage={props.curPage}
            />
          ),
        },
        {
          component: (
            <Button
              onSelectView={props.onSelectView}
              title="Form Logic"
              icon={<FunctionOutlined rev={undefined} />}
              page="form_logic"
              curPage={props.curPage}
            />
          ),
        },
        {
          component: (
            <Button
              onSelectView={props.onSelectView}
              title="Reference Document"
              icon={<IoDocumentTextOutline />}
              page="reference_document"
              curPage={props.curPage}
            />
          ),
        },
        {
          component: (
            <Button
              onSelectView={props.onSelectView}
              title="Reference Information"
              icon={<IoPeopleOutline />}
              page="reference_information"
              curPage={props.curPage}
            />
          ),
        },
        {
          component: (
            <Button
              onSelectView={props.onSelectView}
              title="Approval Matrix"
              icon={<IoMdCheckmarkCircleOutline />}
              page="approval_matrix"
              curPage={props.curPage}
            />
          ),
        },
        {
          component: (
            <Button
              onSelectView={props.onSelectView}
              title="Authorization"
              icon={<IoShieldCheckmarkOutline />}
              page="authorization"
              curPage={props.curPage}
            />
          ),
        },
      ];
      const targetMaster = await GetMasterDataByTypeNames([
        "interface",
        "PDFDesign",
      ]);
      const MergeAPI = targetMaster.find(
        (e: any) =>
          e.MasterType?.toLowerCase() === "interface" && e.IsActive === true
      );
      const isEnabledPDFDesign = targetMaster.find(
        (e: any) =>
          e.MasterType == "PDFDesign" &&
          e.IsActive == true &&
          e.Value1 == "Enabled"
      );
      if (MergeAPI) {
        _sideBarData.push({
          component: (
            <Button
              onSelectView={(e) => props.onSelectView(e)}
              title={"Interface Mapping"}
              icon={<IoCloudUploadOutline />}
              page={"interface_mapping"}
              curPage={props.curPage}
            />
          ),
        });
      }
      if (isEnabledPDFDesign) {
        _sideBarData.push({
          component: (
            <Button
              onSelectView={(e) => props.onSelectView(e)}
              title={"PDF Design"}
              icon={<IoNewspaperOutline />}
              page={"pdf_design"}
              curPage={props.curPage}
            />
          ),
        });
      }
      if (!props.isCopy && props.isVersion) {
        _sideBarData.push({
          component: (
            <Button
              onSelectView={(e) => props.onSelectView(e)}
              title={"Version and History"}
              icon={<IoShieldCheckmarkOutline />}
              page={"version_and_history"}
              curPage={props.curPage}
            />
          ),
        });
      }
      setSideBarData(_sideBarData);
    };
    fetchData();
  }, [props.curPage, props.isCopy, props.isVersion]);

  return (
    <Row className="sidebar-style-display">
      {sideBarData.map((data, idx) => (
        <Col
          xs={12}
          sm={6}
          md={4}
          lg={12}
          xl={12}
          xxl={12}
          style={{ padding: "4px 12px" }}
        >
          <div key={idx}>{data.component}</div>
        </Col>
      ))}
    </Row>
  );
};
